// FanData (Bloco 3 / T-11): cor + nome da criticidade por protocolo, p/ a faixa lateral
// do card. Espelha o `cor` de Fandata::Protocolo (backend). Slugs fixos dos 5 protocolos.
const PROTOCOLO_COR = {
  tolerancia_zero: 'bg-n-ruby-11',
  vermelho: 'bg-n-ruby-9',
  amarelo: 'bg-n-amber-9',
  verde: 'bg-n-teal-9',
  cinza: 'bg-n-slate-8',
};

const PROTOCOLO_NOME = {
  tolerancia_zero: 'Tolerância Zero',
  vermelho: 'Protocolo Vermelho',
  amarelo: 'Protocolo Amarelo',
  verde: 'Protocolo Verde',
  cinza: 'Protocolo Cinza',
};

export const conversationProtocoloSlug = conversation =>
  conversation?.additional_attributes?.fandata_protocolo || null;

export const protocoloBarClass = slug => PROTOCOLO_COR[slug] || null;

export const protocoloNome = slug => PROTOCOLO_NOME[slug] || '';
